import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Frame, Head } from "../components/spec/Frame";
import { useProjects } from "../lib/hooks";
import { requestRepack } from "../frames";
import { PORTFOLIO_PAGE } from "../data/content";
import EngagementCard from "../components/spec/EngagementCard";

const uniq = (arr) => Array.from(new Set(arr.filter(Boolean))).sort();
const selCls = "w-full bg-[#0a0a0a] border border-white/15 focus:border-[#e60000] px-3 py-2.5 text-sm text-white outline-none";

export default function Portfolio() {
  const { data: projects = [], isLoading } = useProjects();
  const [f, setF] = useState({ sector: "", geography: "", service: "" });
  useEffect(() => {
    document.title = "Transformation — REGERA";
  }, []);

  const opts = useMemo(() => ({
    sector: uniq(projects.map((p) => p.sector)),
    geography: uniq(projects.map((p) => p.geography)),
    service: uniq(projects.flatMap((p) => p.services || [])),
  }), [projects]);

  const list = projects.filter((p) =>
    (!f.sector || p.sector === f.sector) &&
    (!f.geography || p.geography === f.geography) &&
    (!f.service || (p.services || []).includes(f.service)));

  useEffect(() => { requestRepack(); }, [isLoading, list.length]);

  const Sel = ({ k, label }) => (
    <label className="block">
      <span className="overline">{label}</span>
      <select data-testid={`filter-${k}`} value={f[k]} onChange={(e) => setF((x) => ({ ...x, [k]: e.target.value }))} className={`${selCls} mt-2`}>
        <option value="">All</option>
        {opts[k].map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    </label>
  );

  return (
    <div data-testid="portfolio-page">
      <Frame id="portfolio-list" first>
        <div className="grid lg:grid-cols-12 gap-8 items-end">
          <Head as="h1" className="lg:col-span-6" {...PORTFOLIO_PAGE} />
          <div className="lg:col-span-6 grid sm:grid-cols-3 gap-4" data-testid="portfolio-filters">
            <Sel k="sector" label="Industry" />
            <Sel k="geography" label="Geography" />
            <Sel k="service" label="Service" />
          </div>
        </div>
        <p className="mt-6 text-xs tracking-[0.14em] uppercase text-white/50" data-testid="portfolio-count">
          {isLoading ? "Loading engagements…" : `${list.length} engagement${list.length === 1 ? "" : "s"}`}
        </p>
        <div className="mt-4 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {list.map((p) => <EngagementCard key={p.slug} p={p} />)}
        </div>
        {!isLoading && list.length === 0 && (
          <p className="mt-4 text-white/60">No engagements match these filters.</p>
        )}
      </Frame>
    </div>
  );
}
